import React, { useState } from 'react'
import {
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import { Link } from 'react-router-dom'
import { useAuth } from '../../auth/Auth'
import './Drawer.css'

const useStyles = makeStyles(() => ({
    link: {
        textDecoration: 'none',
        color: '#FBFBF9 !important',
        fontSize: '20px',
        fontFamily: "'IBM Plex Sans', -apple-system, system-ui, sans-serif",
        fontWeight: '500',
        borderBottom: '1px solid rgba(255,255,255,0.12)',
        display: 'block',
        padding: '6px 0',
    },
    icon: {
        color: 'var(--gp-ink)',
    },
    paper: {
        background: 'var(--gp-ink)',
        color: '#FBFBF9 !important',
        minWidth: '240px',
        padding: '8px 12px',
    },
}))

function DrawerComponent(props) {
    const classes = useStyles()
    const [openDrawer, setOpenDrawer] = useState(false)
    const auth = useAuth()

    return (
        <>
            <Drawer
                classes={{ paper: classes.paper }}
                open={openDrawer}
                anchor={'right'}
                onClose={() => setOpenDrawer(false)}
            >
                <List>
                    <ListItem onClick={() => setOpenDrawer(false)}>
                        <ListItemText>
                            <Link className={classes.link} to="/dashboard">
                                Dashboard
                            </Link>
                        </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => setOpenDrawer(false)}>
                        <ListItemText>
                            <Link className={classes.link} to="/my-account">
                                My Account
                            </Link>
                        </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => setOpenDrawer(false)}>
                        <ListItemText>
                            {!auth.user && (
                                <Link className={classes.link} to="/sign-in">
                                    Login
                                </Link>
                            )}
                            {auth.user && (
                                <div
                                    className={classes.link}
                                    onClick={props.logout}
                                    data-testid="cypress-navbar-logout"
                                >
                                    Sign Out
                                </div>
                            )}
                        </ListItemText>
                    </ListItem>
                </List>
            </Drawer>
            <IconButton
                className={classes.icon}
                onClick={() => setOpenDrawer(!openDrawer)}
            >
                <MenuIcon />
            </IconButton>
        </>
    )
}
export default DrawerComponent
